import { defineStore } from "pinia";
import axios from "axios";
import { router } from "@inertiajs/vue3";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        auth: {},
        token: null,
        isAuthenticated: false,
        locale: "",
        loading: false,
        uploadProgress: false,
        loadingCounter: 0,
        uploadProgressCounter: 0,
        uploadProgressValue: 0,
    }),
    actions: {
        setLoading(loading) {
            this.loadingCounter = loading
                ? this.loadingCounter + 1
                : this.loadingCounter - 1;

            this.loading = loading
                ? true
                : this.loadingCounter <= 0
                  ? false
                  : true;
        },
        setUploadProgress(loading) {
            this.uploadProgressCounter = loading
                ? this.uploadProgressCounter + 1
                : this.uploadProgressCounter - 1;

            this.uploadProgress = loading
                ? true
                : this.uploadProgressCounter <= 0
                  ? false
                  : true;
        },
        setUploadProgressValue(value) {
            this.uploadProgressValue = value;
        },
        setToken(token) {
            this.token = token;
            this.isAuthenticated = !!token;
        },
        async checkIsAuthenticated() {
            if (this.token) {
                this.isAuthenticated = true;
            } else {
                this.isAuthenticated = false;
                this.clearLocalSessionAndCookies();
            }
        },
        // دالة مساعدة لتنظيف الـ الكوكيز والـ LocalStorage يدوياً عند الطوارئ
        clearLocalSessionAndCookies() {
            this.token = null;
            this.auth = {};
            this.isAuthenticated = false;

            // تدمير الهيدر الخاص بـ Axios
            if (window.axios) {
                delete window.axios.defaults.headers.common["Authorization"];
            }

            // تصفير الكوكيز الأساسية لـ Laravel لضمان عدم تعليق المتصفح
            const cookiesToClear = [
                "laravel_session",
                "remember_web",
                "XSRF-TOKEN",
            ];
            cookiesToClear.forEach((cookieName) => {
                document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            });

            console.log(
                "[DEBUG] Auth state and security cookies cleared completely.",
            );
        },
        // 🌟 دالة تسجيل الخروج الرسمية المربوطة بـ web.php 🌟
        async logout() {
            this.setLoading(true);
            try {
                // إرسال طلب الخروج الرسمي للباك إند لتدمير الجلسة وتجهيز الاستجابة
                await axios.post("/logout");
            } catch (error) {
                console.error(
                    "Backend logout request failed or session already dead:",
                    error,
                );
            } finally {
                // تنظيف الفرونت إند تماماً والكوكيز في كل الحوال (سواء نجح طلب axios أو فشل)
                this.clearLocalSessionAndCookies();
                this.setLoading(false);

                // توجيه المتصفح بشكل كامل لصفحة تسجيل الدخول لتحديث الحالة بنسبة 100%
                window.location.href = "/login";
            }
        },
        async checkAdmin() {
            const currentPath = window.location.pathname;

            if (currentPath.startsWith("/admin")) {
                console.log(
                    "Admin Route Detected: Initializing Admin UI settings.",
                );
                document.documentElement.classList.add("admin-mode");
            }
        },
        async getAuth() {
            await axios
                .get("/api/user")
                .then(async (response) => {
                    this.auth = response.data;
                })
                .catch((error) => {
                    console.error("Error fetching authenticated user:", error);
                    // إذا أرجعت الـ API خطأ 401 أو 419، نقوم بعمل خروج تلقائي مجدداً بحماية الستور
                    if (
                        error.response &&
                        (error.response.status === 401 ||
                            error.response.status === 419)
                    ) {
                        this.logout();
                    }
                });
        },
    },
});
